import { render } from "./twentyOnePage.vue?vue&type=template&id=514b219a&scoped=true"
import script from "./twentyOnePage.vue?vue&type=script&lang=js"
export * from "./twentyOnePage.vue?vue&type=script&lang=js"

import "./twentyOnePage.vue?vue&type=style&index=0&id=514b219a&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514b219a"]])

export default __exports__